export const isNullOrEmpty = (str: string | null | undefined) => {
    return str === null || str === undefined || str.trim() === '';
}

export const isNotNullOrEmpty = (str: string | null | undefined) => !isNullOrEmpty(str);

export const isValidEmail = (str: string) => {
    if (str === null || str === undefined) {
        return false;
    }

    const emailValidationRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    return emailValidationRegex.test(str);
}